import React, { useState, useEffect } from "react";
import PartCard from "../components/PartCard";
import PartSearch from "../components/PartSearch";
import { supabase } from "../supabaseClient";
import "./Home.css";

function Home() {
  const [allParts, setAllParts] = useState([]);
  const [filteredParts, setFilteredParts] = useState([]);
  const [sortOption, setSortOption] = useState("none");
  const [announcement, setAnnouncement] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const partsPerPage = 32;

  useEffect(() => {
    const fetchParts = async () => {
      const { data, error } = await supabase.from("parts").select("*").order("created_at", { ascending: false });
      if (error) console.error(error);
      else setAllParts(data);
    };
    fetchParts();

    const banner = localStorage.getItem("announcement");
    if (banner) setAnnouncement(banner);
  }, []);

  const handleSearch = ({ query, brand, model, year, oem, mode }) => {
    let filtered = allParts.filter((part) => {
      const nameMatch = part.name.toLowerCase().includes(query?.toLowerCase() || "");
      const oemMatch = part.oem?.toLowerCase().startsWith(query?.toLowerCase() || "");
      const brandMatch = brand ? part.compatible_vehicles?.some(v => v.brand === brand) : true;
      const modelMatch = model ? part.compatible_vehicles?.some(v => v.model === model) : true;
      const yearMatch = year ? part.compatible_vehicles?.some(v => v.yearFrom <= year && v.yearTo >= year) : true;

      if (mode === "arac") {
        return nameMatch && brandMatch && modelMatch && yearMatch;
      } else {
        return oemMatch;
      }
    });

    if (sortOption === "price_asc") {
      filtered.sort((a, b) => parseFloat(a.tl) - parseFloat(b.tl));
    } else if (sortOption === "price_desc") {
      filtered.sort((a, b) => parseFloat(b.tl) - parseFloat(a.tl));
    }

    setFilteredParts(filtered);
    setCurrentPage(1);
  };

  const handleSortChange = (e) => {
    setSortOption(e.target.value);
    if (filteredParts.length > 0) {
      handleSearch({ query: "", mode: "arac" });
    }
  };

  const partsToShowAll = filteredParts.length > 0 ? filteredParts : allParts;
  const totalPages = Math.ceil(partsToShowAll.length / partsPerPage);
  const partsToShow = partsToShowAll.slice((currentPage - 1) * partsPerPage, currentPage * partsPerPage);

  const logoList = ["lemforder", "luk", "mahle", "meyle", "ferodo", "sachs", "skf"];

  const renderBrandCarousel = () => (
    <div className="brand-carousel-wrapper">
      <div className="brand-carousel">
        <div className="carousel-track">
          {Array.from({ length: 2 }).flatMap(() =>
            logoList.map((logo, idx) => (
              <img
                key={`${logo}-${idx}`}
                src={`/images/logos/${logo}.png`}
                alt={logo}
                className="carousel-logo"
              />
            ))
          )}
        </div>
      </div>
    </div>
  );

  return (
    <div className="home-wrapper">
      <header className="hero-section">
        <img src="/images/erenoto4.webp" alt="Eren Oto Mağaza" className="hero-image" />
        <div className="hero-overlay">
          <h1 className="hero-title">Eren Oto Yedek Parça</h1>
          <p className="hero-subtitle">Volkswagen, Audi, Seat,Porsche,BMW,Mercedes, Skoda Orijinal Yedek Parça</p>
          <div className="brand-buttons mt-3">
            {["vw", "audi", "seat", "skoda", "porsche", "mercedes", "bmw"].map((brand) => (
              <button key={brand} className="brand-button">
                <img
                  src={`/images/logos/${brand}.png`}
                  alt={brand}
                  className="brand-logo enlarged"
                />
              </button>
            ))}
          </div>
        </div>
      </header>

      <main className="container section-transition py-5">
        {announcement && (
          <div className="announcement-banner-wrapper mb-4">
            <div className="announcement-marquee">
              <div
                className="announcement-text"
                dangerouslySetInnerHTML={{ __html: announcement }}
              />
            </div>
          </div>
        )}

        {renderBrandCarousel()}

        <h2 className="section-title text-center">Parça Arama</h2>
        <PartSearch onSearch={handleSearch} />

        <div className="d-flex justify-content-end mb-3">
          <select className="form-select w-auto" value={sortOption} onChange={handleSortChange}>
            <option value="none">Sıralama Yok</option>
            <option value="price_asc">Fiyat (Artan)</option>
            <option value="price_desc">Fiyat (Azalan)</option>
          </select>
        </div>

        <h3 className="section-subtitle mb-3">Mağaza</h3>
        <div className="row g-4">
          {partsToShow.length === 0 ? (
            <p className="text-muted">Üzgünüz, aradığınız kriterlere uygun parça bulunamadı.</p>
          ) : (
            partsToShow.map((part, index) => (
              <div className="col-sm-6 col-md-4 col-lg-3 d-flex" key={`${part.id}-${index}`}>
                <div className="w-100 h-100">
                  <PartCard
                    id={part.id}
                    name={part.name}
                    tl={part.tl}
                    image={part.image_urls?.[0]}
                    compatible_vehicles={part.compatible_vehicles}
                  />
                </div>
              </div>
            ))
          )}
        </div>

        {totalPages > 1 && (
          <div className="pagination-wrapper">
            {Array.from({ length: totalPages }).map((_, index) => (
              <button
                key={index}
                className={`pagination-button ${currentPage === index + 1 ? "active" : ""}`}
                onClick={() => setCurrentPage(index + 1)}
              >
                {index + 1}
              </button>
            ))}
          </div>
        )}

        {renderBrandCarousel()}
      </main>
    </div>
  );
}

export default Home;
